import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, DocumentSchemaSource, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

const mlModel = "ML Model";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.callMlModel,
  category: NodeTypeCategory.ai,
  featureToggle: "feat-core-4382-flows-ml-model-inference-node",
  label: mlModel,
  size: NodeSize.Small,
  controlInputs: [{ name: "call" }],
  controlOutputs: [{ name: "completed" }],
  dataInputs: [],
  documentDataInputListName: "inputs",
  dataOutputs: [],
  documentDataOutputList: "results",
  nodeConfigProperties: [
    {
      name: "mlModelId",
      label: "Operation",
      propertyType: NodeConfigPropertyType.MlModel,
      schemaSourceSystemType: DocumentSchemaSource.mlModel,
      schemaSystem: { createIo: true }
    },
    {
      name: "mlModelName",
      propertyType: NodeConfigPropertyType.NoInput,
      schemaSourceSystemType: DocumentSchemaSource.mlModel
    },
    {
      name: "inputs",
      sectionName: "Input",
      propertyType: NodeConfigPropertyType.EnabledInputs
    },
    {
      name: "results",
      sectionName: "results",
      propertyType: NodeConfigPropertyType.EnabledOutputs
    }
  ],
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const CallMlModelNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  let label = data.nodeProperties.mlModelName ?? mlModel;
  data.nodeProperties.label = label;
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
